import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import museumImg from "../../assets/images/Home/img1.jpg";
import ratnagiriImg from "../../assets/images/Home/Ratanagiri.jpg";
import nashikimg from "../../assets/images/Home/Nashik Regional Museum.jpg";
import aundhimg from "../../assets/images/Home/Aundh Museum.jpg";
import chandrakantmandhareimg from "../../assets/images/Home/Kolhapur- Chandrakant Mandhare Museum.jpg";
import paithanimg from "../../assets/images/Home/Paithan Regional Museum.jpg";

import monumentImg from "../../assets/images/Home/img2.jpg";
import raigad from "../../assets/images/Monuments Images/Pune/13.Rajgad Fort/DroneView (40).jpg";
import vishrambaug from "../../assets/images/Monuments Images/Pune/15.Vishrambaug Wada/DSC00015.JPG";
import sangramdurg from "../../assets/images/Monuments Images/Pune/16.Sangramdurg Fort/DJI_0484.JPG";
import mastani11 from "../../assets/images/Monuments Images/Pune/9.Mastani tomb/7.jpg";
import mahadev from "../../assets/images/Monuments Images/Pune/10.Mahadev Temple/Mahadev_Temple_Tulapur_East_Elevation_4.jpg";

import excavationImg from "../../assets/images/Home/excavationouratt.jpg";
import excavationImg1 from "../../assets/images/Excavationimg/DSC00752.jpg";
import excavationImg2 from "../../assets/images/Excavationimg/DSC00761.jpg";
import excavationImg3 from "../../assets/images/Excavationimg/DSC00776.jpg";
import excavationImg4 from "../../assets/images/Excavationimg/DSC00781.jpg";
import excavationImg5 from "../../assets/images/Excavationimg/DSC00787.jpg";

  const museumImages = [
        museumImg,
        ratnagiriImg,
        nashikimg,
        aundhimg,
        chandrakantmandhareimg,
        paithanimg,
    ];

    const monumentImages = [
        monumentImg,
        raigad,
        vishrambaug,
        sangramdurg,
        mastani11,
        mahadev,
    ];

    const excavationImages = [
        excavationImg,
        excavationImg1,
        excavationImg2,
        excavationImg3,
        excavationImg4,
        excavationImg5,
    ];

const OurAttraction = () => {
    const selectedLang = useSelector((state) => state.language.selectedLang);
    const navigate = useNavigate();
    const convertToMarathiNumber = (num) => {
        const marathiDigits = ["०", "१", "२", "३", "४", "५", "६", "७", "८", "९"];
        return num
            .toString()
            .split("")
            .map(d => marathiDigits[d] ?? d)
            .join("");
    };

    const MUSEUM_COUNT = 13;
    const MONUMENT_COUNT = 390;


    const langContent = {
        English: {
            attractions: "Our Attractions",
            explore: "Explore",
            monuments: "Monuments and Sites",
            museums: "Museums",
            excavations: "Excavations & Explorations",
        },
        मराठी: {
            attractions: "मुख्य आकर्षणे",
            explore: "अन्वेषण करा",
            monuments: "स्मारके व पुरास्थळे",
            museums: "संग्रहालये",
            excavations: "उत्खनन आणि अन्वेषण",

        }
    };
    const text = langContent[selectedLang];

    const [museumIndex, setMuseumIndex] = useState(0);
    const [monumentIndex, setMonumentIndex] = useState(0);
    const [excavationIndex, setExcavationIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setMuseumIndex((i) => (i + 1) % museumImages.length);
            setMonumentIndex((i) => (i + 1) % monumentImages.length);
            setExcavationIndex((i) => (i + 1) % excavationImages.length);
        }, 2000);

        return () => clearInterval(interval);
    }, []);

    const [clickedCard, setClickedCard] = useState(null);

    const handleNavigateWithClick = (path, key) => {
        setClickedCard(key); // mark which card is clicked
        setTimeout(() => {
            setClickedCard(null); // reset after animation
            navigate(path); // navigate
        }, 400);
    };


    return (
        <div className="relative overflow-hidden">
            <div
                className="relative px-4 sm:px-6 lg:px-20 bg-cover bg-center no-dark-bg py-2 md:py-5 lg:py-2 mt-1"
            // style={{ backgroundImage: `url(${attractionBg})` }}
            >
                {/* Heading */}
                <div className="text-center ">
                    <h2 className="text-xl sm:text-4xl md:text-3xl mb-3">
                        {text.attractions}
                    </h2>
                </div>

                {/* Cards Section */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-5xl mx-auto">
                    {/* Museums (Large Card) */}
                    <button
                        type="button"
                        onClick={() => handleNavigateWithClick("/museums")}
                        className="relative w-full text-left rounded-xl overflow-hidden shadow-lg group cursor-pointer p-0 border-0 bg-transparent"
                    >
                        <img
                            src={museumImages[museumIndex]}
                            alt="Museums"
                            className="w-full h-48 object-cover sm:h-64 md:h-[450px] lg:h-[450px] transform transition-all duration-1000 ease-in-out group-hover:scale-110"
                        />
                        {/* Count Badge */}
                        <div className="absolute top-3 right-3 bg-white text-black text-xs sm:text-sm px-2 sm:px-3 py-1 rounded-full">
                            {selectedLang === "English"
                                ? `Total Museums: ${MUSEUM_COUNT}`
                                : `एकूण संग्रहालये: ${convertToMarathiNumber(MUSEUM_COUNT)}`}
                        </div>

                        {/* <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent group-hover:from-black/80 transition duration-300" /> */}
                        <p className="absolute bottom-4 left-4 text-white text-lg">{text.museums}</p>
                        <p
                            className={`
      absolute bottom-4 right-4 flex items-center gap-1 text-lg transition-all duration-300 ease-in-out
      ${clickedCard === "museums"
                                    ? "text-white font-bold opacity-100"
                                    : "text-white/70 opacity-0 group-hover:opacity-100"}
    `}
                        >
                            {text.explore}
                            <span
                                className={`
        inline-block transform transition-transform duration-300
        ${clickedCard === "museums" ? "translate-x-2" : "translate-x-0 group-hover:translate-x-1"}
      `}
                            >
                                →
                            </span>
                        </p>
                    </button>

                    {/* Monuments + Excavations (Stacked Column) */}
                    <div className="flex flex-col gap-6">
                        {/* Monuments */}
                        <button
                            type="button"
                            onClick={() => handleNavigateWithClick("/monuments")}
                            className="relative w-full text-left rounded-xl overflow-hidden shadow-lg group cursor-pointer p-0 border-0 bg-transparent"
                        >
                            <div className="relative w-full h-48 sm:h-64 md:h-[215px] overflow-hidden group">
                                <img
                                    src={monumentImages[monumentIndex]}
                                    alt="Monuments"
                                    className="w-full h-full object-cover object-top  transform transition-all duration-1000 ease-in-out group-hover:scale-110"
                                />
                                {/* Count Badge */}
                                <div className="absolute top-3 right-3 bg-white text-black text-xs sm:text-sm px-2 sm:px-3 py-1 rounded-full z-10">
                                    {selectedLang === "English"
                                        ? `Total Monuments: ${MONUMENT_COUNT}`
                                        : `एकूण स्मारके: ${convertToMarathiNumber(MONUMENT_COUNT)}`}
                                </div>

                                {/* Bottom Black Gradient */}
                                <div className="absolute bottom-0 left-0 right-0 h-1/2 bg-gradient-to-b from-transparent to-black opacity-60"></div>
                            </div>

                            {/* <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent group-hover:from-black/80 transition duration-300" /> */}
                            <p className="absolute bottom-4 left-4 text-white text-lg">{text.monuments}</p>

                            <p
                                className={`
      absolute bottom-4 right-4 flex items-center gap-1 text-lg transition-all duration-300 ease-in-out
      ${clickedCard === "museums"
                                        ? "text-white font-bold opacity-100"
                                        : "text-white/70 opacity-0 group-hover:opacity-100"}
    `}
                            >
                                {text.explore}
                                <span
                                    className={`
        inline-block transform transition-transform duration-300
        ${clickedCard === "museums"
                                            ? "translate-x-2"
                                            : "translate-x-0 group-hover:translate-x-1"}
      `}
                                >
                                    →
                                </span>
                            </p>
                        </button>

                        {/* Excavations */}
                        <button
                            type="button"
                            onClick={() => handleNavigateWithClick("/excavations")}
                            className="relative w-full text-left rounded-xl overflow-hidden shadow-lg group cursor-pointer p-0 border-0 bg-transparent"
                        >
                            <div className="relative w-full h-48 sm:h-64 md:h-[215px] overflow-hidden group">
                                <img
                                    src={excavationImages[excavationIndex]}
                                    alt="Excavations"
                                    className="w-full h-full object-cover object-top transform transition-all duration-1000 ease-in-out group-hover:scale-110"
                                />

                                {/* Bottom Black Gradient */}
                                <div className="absolute bottom-0 left-0 right-0 h-1/2 bg-gradient-to-b from-transparent to-black opacity-60"></div>
                            </div>

                            {/* <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent group-hover:from-black/80 transition duration-300" /> */}

                            <p className="absolute bottom-4 left-4 text-white text-lg">
                                {text.excavations}
                            </p>

                            <p
                                className={`
      absolute bottom-4 right-4 flex items-center gap-1 text-lg transition-all duration-300 ease-in-out
      ${clickedCard === "museums"
                                        ? "text-white font-bold opacity-100"
                                        : "text-white/70 opacity-0 group-hover:opacity-100"}
    `}
                            >
                                {text.explore}
                                <span
                                    className={`
        inline-block transform transition-transform duration-300
        ${clickedCard === "museums"
                                            ? "translate-x-2"
                                            : "translate-x-0 group-hover:translate-x-1"}
      `}
                                >
                                    →
                                </span>
                            </p>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OurAttraction;
